import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  declare checkboxTarget: HTMLInputElement
  declare submitButtonTarget: HTMLButtonElement
  declare hasTimezoneTarget: boolean
  declare timezoneTarget: HTMLInputElement

  static targets = ["checkbox", "submitButton", "timezone"]

  connect() {
    this.toggle()
    this.setTimezone()
  }

  toggle() {
    this.submitButtonTarget.disabled = !this.checkboxTarget.checked
  }

  setTimezone() {
    if (!this.hasTimezoneTarget) return

    this.timezoneTarget.value = Intl.DateTimeFormat().resolvedOptions().timeZone
  }
}
